/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable import/no-extraneous-dependencies */
import { createRef, useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Card, CardContent, CardDescription } from "@repo/ui";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { process } from "@progress/kendo-data-query";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { PATHS } from "routes/paths";
import { useExportCalls, useGetCancelledCalls } from "services/tickets";
import Loader from "ui/page-loader";
import { BreadCrumb } from "ui/bread-crumbs";
import { FiltersContext } from "store/filters-context";
import FilterBarV2 from "../common/filter-bar";
import { StatusContext } from "../constants";
import {
  fixKendoGridContent,
  getCurrentTicketScreen,
  isFilterUpdated,
} from "../utils";
import GridDataCopyCell from "components/copy";

export default function CCACancelledCallsList() {
  const [dataState, setDataState] = useState({
    sort: [
      {
        field: "code",
        dir: "asc",
      },
    ],
  });
  const [tickets, setTickets] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const { filters } = useContext(FiltersContext);
  const [localFilters, setLocalFilters] = useState({
    searchCriteria: filters?.searchCriteria?.value || "",
    period: filters?.period?.value || "All",
    cashCenterId: filters?.cashCenterId?.value || "",
    customerId: filters?.customerId?.value || "",
    assetId: filters?.assetId?.value || "",
    activityType: filters?.activityType?.value || "",
    assignmentGroup: filters?.assignmentGroup?.value || "",
  });

  const { setStatus } = useContext(StatusContext);

  const pageSize = 100;
  const _exporter = createRef();
  useEffect(() => {
    const nextFilters = {
      searchCriteria: filters?.searchCriteria?.value || "",
      period: filters?.period?.value || "All",
      cashCenterId: filters?.cashCenterId?.value || "",
      customerId: filters?.customerId?.value || "",
      assetId: filters?.assetId?.value || "",
      activityType: filters?.activityType?.value || "",
      assignmentGroup: filters?.assignmentGroup?.value || "",
    };

    if (isFilterUpdated(localFilters, nextFilters)) {
      setLocalFilters({ ...nextFilters });
    }
  }, [filters]);
  const {
    mutate: getTickets,
    data: ticketsList,
    isPending: gettingTickets,
    reset: resetGetTickets,
  } = useGetCancelledCalls();

  const {
    mutate: getAllTickets,
    data: allTicketsData,
    isPending: gettingAllTickets,
    reset: getAllTicketsReset,
  } = useExportCalls();

  useEffect(() => {
    if (allTicketsData) {
      excelExport();
      getAllTicketsReset();
    }
  }, [allTicketsData]);
  useEffect(() => {
    setCurrentPage(1);
    getTickets({
      pageNumber: 1,
      pageRowCount: pageSize,
      ...localFilters,
    });
  }, [localFilters]);

  useEffect(() => {
    if (ticketsList) {
      setTotalRecords(ticketsList.data.totalRecords);
      setTickets(
        ticketsList.data.data.map((elm) => ({ ...elm, expanded: false }))
      );
      resetGetTickets();
    }
  }, [ticketsList]);

  const excelExport = () => {
    if (_exporter.current) {
      _exporter.current.save();
    }
  };
  const onPageChange = (e) => {
    const _page = e.page.skip / pageSize + 1;
    setCurrentPage(_page);
    getTickets({
      pageNumber: _page,
      pageRowCount: pageSize,
      ...localFilters,
    });
  };

  const onRefresh = () => {
    getTickets({
      pageNumber: currentPage,
      pageRowCount: pageSize,
      ...localFilters,
    });
  };

  return (
    <div className="box-border">
      {gettingTickets ? <Loader /> : <></>}
      <BreadCrumb
        className="mx-4"
        items={[
          { text: "CCA Calls", to: PATHS.allCalls },
          { text: "Cancelled Calls" },
        ]}
      />
      <Card className="mx-4 mt-5">
        <CardContent>
          <CardDescription className="pt-6">
            <FilterBarV2
              hideStatus
              exportExcel
              onRefresh={onRefresh}
              exportingExcel={gettingAllTickets}
              onExcelExport={() => {
                getAllTickets({
                  status: "Cancelled",
                  ...localFilters,
                });
              }}
            />
          </CardDescription>

          <Grid
            data={process(tickets || [], dataState)}
            {...dataState}
            onDataStateChange={(e) => {
              e.dataState.skip = 0;
              setDataState(e.dataState);
            }}
            className="list-tables-v1"
            filterable
            width="100%"
            sortable
            pageable
            total={totalRecords}
            pageSize={pageSize}
            skip={(currentPage - 1) * pageSize}
            onPageChange={onPageChange}
            ref={(e) => {
              fixKendoGridContent(e);
            }}
          >
            <GridColumn
              title="Open At"
              field="createDateTime"
              width="120px"
              className="text-center"
              headerClassName="text-center"
            />
            <GridColumn
              title="Cancel At"
              field="cancelledDateTime"
              width="120px"
              className="text-center"
              headerClassName="text-center"
            />
            <GridColumn
              title="State"
              field="status"
              width="150px"
              className="text-center"
              headerClassName="text-center"
              filterable
            />
            <GridColumn title="Account" field="customer" width="170px" />
            <GridColumn title="Asset Id" field="locationId" width="150px" />
            <GridColumn
              title="Ticket Number"
              width="170px"
              field="caseNo"
              cell={(items) => {
                const dataItem = items.dataItem;
                return (
                  <GridDataCopyCell
                    dataItem={items.dataItem}
                    field={items.field}
                    customCell={
                      <td>
                        <Link
                          onClick={() => {
                            setStatus("cancelled");
                          }}
                          to={getCurrentTicketScreen(dataItem)}
                        >
                          {dataItem.status === "Draft"
                            ? "View Draft"
                            : dataItem.caseNo}
                        </Link>
                      </td>
                    }
                  />
                );
              }}
            />
            <GridColumn
              title="Bank Reference/Address"
              field="customerTicketNo"
              width="200px"
            />
            <GridColumn
              title="Activity Type"
              field="activityType"
              width="170px"
            />
            <GridColumn title="Category" field="category" width="150px" />
            <GridColumn
              title="Sub Category"
              field="subCategory"
              width="150px"
            />
            <GridColumn title="Location" field="locationName" width="170px" />
            <GridColumn title="Region" field="region" width="150px" />
            <GridColumn
              title="Assignment Group"
              field="assignmentGroup"
              width="170px"
            />
            <GridColumn title="Reported By" field="reportedBy" width="170px" />
            <GridColumn title="Description" field="remarks" width="400px" />
            <GridColumn
              title="Resolution Notes"
              field="resolutionNotes"
              width="170px"
            />
          </Grid>
          <ExcelExport
            data={allTicketsData?.data.data || []}
            fileName="Cancelled-Tickets.xlsx"
            ref={_exporter}
          >
            <GridColumn
              title="Created At"
              field="createDateTime"
              width="170px"
            />
            <GridColumn
              title="Cancelled At"
              field="cancelledDateTime"
              width="170px"
            />
            <GridColumn title="State" field="status" width="200px" />
            <GridColumn title="Account" field="customer" width="170px" />
            <GridColumn title="Asset Id" field="locationId" width="150px" />
            <GridColumn title="Ticket Number" width="170px" field="caseNo" />
            <GridColumn
              title="Bank Reference/Address"
              field="customerTicketNo"
            />
            <GridColumn
              title="Activity Type"
              field="activityType"
              width="170px"
            />
            <GridColumn title="Category" field="category" width="150px" />
            <GridColumn
              title="Sub Category"
              field="subCategory"
              width="150px"
            />
            <GridColumn title="Location" field="locationName" width="170px" />
            <GridColumn title="Region" field="region" width="150px" />
            <GridColumn
              title="Assignment Group"
              field="assignmentGroup"
              width="170px"
            />
            <GridColumn title="Reported By" field="reportedBy" width="170px" />
            <GridColumn title="Description" field="remarks" width="170px" />
            <GridColumn
              title="Resolution Notes"
              field="resolutionNotes"
              width="170px"
            />
            <GridColumn title="Opened By" field="openedBy" width="170px" />
            <GridColumn title="Closed By" field="closedBy" width="170px" />
          </ExcelExport>
        </CardContent>
      </Card>
    </div>
  );
}
